{
  "Timezone_Default": "Default",
  "Timezone_International_Date_Line_West": "(GMT-12:00) International Date Line West",
  "Timezone_Midway": "(GMT-11:00) Midway Island",
  "Timezone_Hawaii": "(GMT-10:00) Hawaii",
  "Timezone_Alaska_DLS": "(GMT-09:00) Alaska [DLS]",
  "Timezone_Pacific_Time_US_Canada_DLS": "(GMT-08:00) Pacific Time (US / Canada) [DLS]",
  "Timezone_Tijuana_Baja_California_DLS": "(GMT-08:00) Tijuana, Baja California [DLS]",
  "Timezone_Arizona": "(GMT-07:00) Arizona",
  "Timezone_Chihuahua_La_Paz_Mazatlan": "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
  "Timezone_Mountain_Time_US_Canada_DLS": "(GMT-07:00) Mountain Time (US / Canada) [DLS]",
  "Timezone_Central_America": "(GMT-06:00) Central America",
  "Timezone_Central_Time_US_Canada_DLS": "(GMT-06:00) Central Time (US / Canada) [DLS]",
  "Timezone_Guadalajara_Mexico_City_Monterrey": "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
  "Timezone_Saskatchewan": "(GMT-06:00) Saskatchewan",
  "Timezone_Bogota_Lima_Quito_Rio_Branco": "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
  "Timezone_Eastern_Time_US_Canada_DLS": "(GMT-05:00) Eastern Time (US / Canada) [DLS]",
  "Timezone_Indiana_East_DLS": "(GMT-05:00) Indiana (East) [DLS]",
  "Timezone_Caracas": "(GMT-04:00) Caracas",
  "Timezone_Atlantic_Time_Canada_DLS": "(GMT-04:00) Atlantic Time (Canada) [DLS]",
  "Timezone_La_Paz": "(GMT-04:00) La Paz",
  "Timezone_Manaus": "(GMT-04:00) Manaus",
  "Timezone_Georgetown": "(GMT-04:00) Georgetown",
  "Timezone_Santiago_DLS": "(GMT-04:00) Santiago [DLS]",
  "Timezone_Newfoundland_DLS": "(GMT-03:30) Newfoundland [DLS]",
  "Timezone_Brasilia": "(GMT-03:00) Brasilia",
  "Timezone_Buenos_Aires": "(GMT-03:00) Buenos Aires",
  "Timezone_Montevideo": "(GMT-03:00) Montevideo",
  "Timezone_Greenland_Godthab_DLS": "(GMT-02:00) Greenland (Godthab, Nuuk) [DLS]",
  "Timezone_Mid_Atlantic": "(GMT-02:00) Mid-Atlantic",
  "Timezone_Azores_DLS": "(GMT-01:00) Azores [DLS]",
  "Timezone_Cape_Verde_Islands": "(GMT-01:00) Cape Verde Islands",
  "Timezone_Dublin_Edinburgh_Lisbon_London_DLS": "(GMT+00:00) Dublin, Edinburgh, Lisbon, London [DLS]",
  "Timezone_Greenwich_Mean_Time": "(GMT+00:00) Greenwich Mean Time",
  "Timezone_Monrovia_Reykjavik": "(GMT+00:00) Monrovia, Reykjavik",
  "Timezone_Amsterdam_Berlin_Rome_Bern_Vienna_DLS": "(GMT+01:00) Amsterdam, Berlin, Rome, Bern, Vienna [DLS]",
  "Timezone_Belgrade_Bratislava_Budapest_Prague_DLS": "(GMT+01:00) Belgrade, Bratislava, Budapest, Prague [DLS]",
  "Timezone_Brussels_Copenhagen_Madrid_Paris_DLS": "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris [DLS]",
  "Timezone_Sarajevo_Skopje_Warsaw_Zagreb_DLS": "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb [DLS]",
  "Timezone_Casablanca_DST": "(GMT+01:00) Casablanca [DLS]",
  "Timezone_West_Central_Africa": "(GMT+01:00) West Central Africa",
  "Timezone_Windhoek": "(GMT+02:00) Windhoek",
  "Timezone_Athens_Bucharest": "(GMT+02:00) Athens; Bucharest",
  "Timezone_Beirut_DLS": "(GMT+02:00) Beirut [DLS]",
  "Timezone_Cairo_DLS": "(GMT+02:00) Cairo [DLS]",
  "Timezone_Harare_Pretoria": "(GMT+02:00) Harare, Pretoria",
  "Timezone_Helsinki_Kyiv_Riga_Sofia_Tallinn_Vilnius_DLS": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius [DLS]",
  "Timezone_Jerusalem_DLS": "(GMT+02:00) Jerusalem [DLS]",
  "Timezone_Baghdad_DLS": "(GMT+03:00) Baghdad [DLS]",
  "Timezone_Amman": "(GMT+03:00) Amman; Istanbul",
  "Timezone_Kuwait_Riyadh": "(GMT+03:00) Kuwait, Riyadh",
  "Timezone_Moscow_St_Petersburg_Volgograd": "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
  "Timezone_Minsk": "(GMT+03:00) Minsk",
  "Timezone_Nairobi": "(GMT+03:00) Nairobi",
  "Timezone_Tehran": "(GMT+03:30) Tehran",
  "Timezone_Tbilisi": "(GMT+04:00) Tbilisi",
  "Timezone_Abu_Dhabi_Muscat": "(GMT+04:00) Abu Dhabi, Muscat",
  "Timezone_Baku": "(GMT+04:00) Baku",
  "Timezone_Mauritius": "(GMT+04:00) Mauritius, Port Louis",
  "Timezone_Yerevan_DLS": "(GMT+04:00) Yerevan [DLS]",
  "Timezone_Kabul": "(GMT+04:30) Kabul",
  "Timezone_Yekaterinburg": "(GMT+05:00) Yekaterinburg",
  "Timezone_Islamabad_Karachi": "(GMT+05:00) Islamabad, Karachi",
  "Timezone_Tashkent": "(GMT+05:00) Tashkent, Astana, Almaty",
  "Timezone_Chennai_Kolkata_Mumbai_New_Delhi": "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
  "Timezone_Sri_Jayawardenepura": "(GMT+05:30) Colombo, Sri Jayawardenepura",
  "Timezone_Katmandu": "(GMT+05:45) Katmandu",
  "Timezone_Dhaka": "(GMT+06:00) Dhaka",
  "Timezone_Yangon_Rangoon": "(GMT+06:30) Yangon (Rangoon)",
  "Timezone_Bangkok_Jakarta": "(GMT+07:00) Bangkok, Jakarta",
  "Timezone_Krasnoyarsk": "(GMT+07:00) Krasnoyarsk",
  "Timezone_Novosibirsk": "(GMT+07:00) Novosibirsk",
  "Timezone_Hong_Kong": "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
  "Timezone_Irkutsk": "(GMT+08:00) Irkutsk, Ulaan Bataar",
  "Timezone_Kuala_Lumpur": "(GMT+08:00) Kuala Lumpur, Singapore",
  "Timezone_Perth": "(GMT+08:00) Perth",
  "Timezone_Taipei": "(GMT+08:00) Taipei",
  "Timezone_Tokyo": "(GMT+09:00) Osaka, Sapporo, Tokyo",
  "Timezone_Seoul": "(GMT+09:00) Seoul",
  "Timezone_Yakutsk": "(GMT+09:00) Yakutsk",
  "Timezone_Adelaide": "(GMT+09:30) Adelaide [DLS]",
  "Timezone_Darwin": "(GMT+09:30) Darwin",
  "Timezone_Brisbane": "(GMT+10:00) Brisbane",
  "Timezone_Canberra_Melbourne_Sydney": "(GMT+10:00) Canberra, Melbourne, Sydney [DLS]",
  "Timezone_Port_Moresby": "(GMT+10:00) Guam, Port Moresby",
  "Timezone_Hobart": "(GMT+10:00) Hobart [DLS]",
  "Timezone_Vladivostok": "(GMT+10:00) Vladivostok",
  "Timezone_Magadan": "(GMT+11:00) Magadan, Solomon Islands, New Caledonia",
  "Timezone_Auckland_Wellington": "(GMT+12:00) Auckland, Wellington [DLS]",
  "Timezone_Fiji": "(GMT+12:00) Fiji, Kamchatka, Marshall Islands",
  "Timezone_Tongatapu": "(GMT+13:00) Tongatapu",
  "Timezone_Samoa": "(GMT+13:00) Samoa",
  "Timezone_Kiritimati": "(GMT+14:00) Kiritimati, Christmas Island",
  "NAME": "Timezone"
}
